import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link, Typography, Button } from '@one-thd/sui-atomic-components';
var NoOrdersView = function (_a) {
    var setOpenAddReceiptModal = _a.setOpenAddReceiptModal, customerType = _a.customerType, activeFilter = _a.activeFilter;
    var navigate = useNavigate();
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-6" },
        React.createElement("div", null,
            React.createElement("div", { className: "sui-mb-2" },
                React.createElement(Typography, { weight: "bold" }, activeFilter
                    ? 'There are no purchases found for the selected dates.'
                    : 'Try selecting another date filter to view your orders.')),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-8 md:sui-w-[600px]" },
                React.createElement("div", { className: "sui-flex" },
                    React.createElement(Typography, null,
                        "You can see all of your purchases made online or in-store here. Add a registered card to your",
                        ' ',
                        React.createElement(Link, { onClick: function () { return navigate('/myaccount/payments'); } }, "Cards & Accounts"),
                        customerType === 'b2c' ? null : (React.createElement(React.Fragment, null,
                            ", or",
                            ' ',
                            React.createElement(Link, { onClick: function () { return setOpenAddReceiptModal(true); } }, "Add a Receipt"),
                            ' ',
                            "to see in-store purchases")),
                        ".")),
                React.createElement(Button, { href: "https://www.homedepot.com", variant: "primary" }, "Start Shopping")))));
};
export default NoOrdersView;
